/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HandRequestSpeakListIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACL0lEQVR4nM2Vv2sUURDHY1QURURsTBRsLcROiyBudXBmd35sYG9m7wyBFAd2VmqhLGijjSCxkBRWIgoqCoKi4I8E/wA7K7EMGE2j4k8ib/ft3sbb2/P2UjjwYOe9t/N58533Y2TkfzBE3OGxHHdmZrYaPwiCjcg6SyQT6wIAlvvIuoqkc8b3SKZjn+Wz4zibhgYgy1ICkFsJUG9bwJLxJ4NgD5BcrZSR6zZ3JcHidimKolEgWbaAuzbD68YH1lcDA4hkIgUAy0nm8Ejmk54ydQGWFTt+ZWAAss5mGfjqIuu51Pf8xmFgDbNxbByrAJDLaQDXbxxEksW0wO12ezOwPEmykeV+Bd9Qq53Y3gUgfZACfL+1D0h+WL2fu26wF0h/Wf8Goo4D6zMgOd8VHVhfAMlvIL0ZBMHOXP9bq++KRyHnCn4BWc525FEEkms2uw9FgIVsMslLs1vq9foWZP3ZCSqfsgL7Wk/hRq7JqeZ+IP1q5ZrvAngcHs2tbhX9RivWPN+XbySPO996D0guZnDQQ4VFAJJHudW+AdLTPQFrYXeA9KP9ftp7x6DivwQE0u8xHHW8bNd0y+R525D1S3+AnBko8BqZWB72A/h+ayyZq69LZFvsf3K5uGVzs0NXkCXrQiGAeXo3sn4rA0RRNFpZojh1kvkygGOvhEoSZVmQvO/1s7mDKkuUmjcVHkDWd2WAoc08NualMldBEaCyRH+buWXB1xqwtImkmfYPJdF62R8OpgUFqEupKwAAAABJRU5ErkJggg==)
 */
export const HandRequestSpeakListIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.02 3.06a1.23 1.23 0 0 0-2.39-.6l-2.14 7.76-.61-.24.83-6.97a1.26 1.26 0 0 0-2.49-.34L8.13 9.65l-.47 2.86a.42.42 0 0 1-.8.1l-.66-1.47a3.92 3.92 0 0 0-1.85-1.9l-.32-.17a1.53 1.53 0 0 0-1.91.47.61.61 0 0 0-.05.65l1.33 2.5c.06.12.12.24.16.37l1.26 4.11a7.47 7.47 0 0 0 7.77 5.25.48.48 0 0 0 .43-.48v-2.59L13 16a3 3 0 0 1 3-3h4.2a.5.5 0 0 0 .47-.3l1.23-2.9a1.19 1.19 0 0 0-2.17-.97l-1.8 3.87-.56-.22 2.4-7.64a1.17 1.17 0 0 0-2.21-.75l-2.78 7.4-.67-.26 1.9-8.17Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 15a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6ZM16 18a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6ZM16 21a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
        className={colorClass}
      />
    </svg>
  );
};
